module.exports = __webpack_public_path__ + "components/flag/static/square/pa-55b4e6d391c7ec5c13f6827f7fdc40d5.svg";